import React from 'react'

import { Theme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

function withMobile<T>(WrappedComponent: React.FC<T>) {
  return (props: T): JSX.Element => {
    const isMobile = useMediaQuery((theme: Theme) =>
      theme.breakpoints.down('sm')
    )

    return <WrappedComponent isMobile={isMobile} {...props} />
  }
}

export default withMobile
